export const TAKE_LOCATION_EXPAND_MS = 150;
export const TAKE_LOCATION_COLLAPSE_MS = 120;
export const TAKE_LOCATION_COLLAPSE_EVENT = "take-location-collapse";
